module.exports = __webpack_public_path__ + "img/sharePYQ.d308bb4c.png";